import { getNowDateContainer } from './get-now-date-container';

export const isNowDateContainer = (deliveryDate: string) =>
  deliveryDate === getNowDateContainer();
